const normalizePath = (url: string) => {
  const path = url
    .split('?')[0]
    .replace(/^https?:\/\/[^/]+\//, '')
    .replace(/^\/+/, '')
  return path.replace(/^api\//, '')
}

const MINI_ORDER_PATHS = new Set([
  'my_all_orders',
  'get_orders_with_state',
  'get_orders_statistics',
  'get_pre_order_info',
  'order_submit',
  'order_confirm',
  'get_order_infos',
  'delete_order_information',
  'add_invoicing_information',
  'my_bills',
  'create_order',
])

/** Positive allowlist: user-scoped endpoints must never receive X-Customer-Id. */
export const isCustomerScopedRequest = (url = '', method = 'GET') => {
  const path = normalizePath(url)
  const verb = method.toUpperCase()

  if (path === 'customer-context/customers/current' && verb === 'PATCH') return true
  if (/^webofficial\/client-orders(?:\/|$)/.test(path)) return true
  if (/^v2\/designer-files(?:\/|$)/.test(path)) return true
  if (/^webofficial\/print-orders(?:\/|$)/.test(path)) return true
  if (/^webofficial\/design-outsourcing(?:\/|$)/.test(path)) return true
  if (/^webofficial\/scan-outsourcing(?:\/|$)/.test(path)) return true
  if (/^webofficial\/documents(?:\/|$)/.test(path)) return true
  if (/^payment\/client\/(create|balance_pay|monthly_pay|monthly-settlement|method-capabilities)$/.test(path)) {
    return true
  }
  if (/^webofficial\/wallet\/monthly-card(?:\/|$)/.test(path)) return true
  if (/^miniprogram\/after-sales(?:\/|$)/.test(path)) return true
  if (/^miniprogram\/(commerce-cart\/checkout|design\/submit|scanning\/submit)$/.test(path)) {
    return true
  }

  const miniOrderPath = path.match(/^miniprogram\/([^/]+)$/)?.[1]
  if (miniOrderPath && MINI_ORDER_PATHS.has(miniOrderPath)) return true

  if (/^webofficial\/commerce\/(checkout|orders)(?:\/|$)/.test(path)) return true
  if (/^webofficial\/orders(?:\/|$)/.test(path) && !/^webofficial\/orders\/shop(?:\/|$)/.test(path)) {
    return true
  }
  if (path === 'webofficial/ai3d/membership/purchase' && verb === 'POST') return true
  if (/^webofficial\/(scanning|design)\/orders$/.test(path) && verb === 'POST') return true
  if (/^webofficial\/(scanning|design)\/orders\/[^/]+$/.test(path) && verb === 'GET') return true

  return false
}
